import { Input, Directive } from "@angular/core";
import { Subject } from "rxjs";

@Directive()
export abstract class AutocompleteComponent<T> {

  public autocompleteName: string = 'item';

  @Input() limparDepoisDeSelecionar: boolean = false;
  @Input() placeholder: string;

  abstract getObjetoSelecionado(): T;

  abstract setObjetoSelecionado(o: T): void;

  abstract getSubject(): Subject<T>;

  public limparDDL(): void {
    this.setObjetoSelecionado(null);
    this.getSubject().next(null);
  }

  public onSelect(event: T): void {
    this.getSubject().next(event);

    if ( this.limparDepoisDeSelecionar ) {
      setTimeout(() => {
        this.limparDDL();
      }, 650);
    }
  }

  public onClear(): void {
    this.limparDDL();
  }

  public onBlur(event: any): void {};

  abstract search(event: any): void;

}